/** Formateadores de presentación del NOC (es-CO). */

const copFormatter = new Intl.NumberFormat('es-CO', {
  style: 'currency',
  currency: 'COP',
  maximumFractionDigits: 0,
});

const integerFormatter = new Intl.NumberFormat('es-CO', { maximumFractionDigits: 0 });

export function formatCop(value: number): string {
  if (!Number.isFinite(value)) {
    return '—';
  }
  return copFormatter.format(Math.round(value));
}

export function formatInteger(value: number): string {
  if (!Number.isFinite(value)) {
    return '—';
  }
  return integerFormatter.format(Math.round(value));
}

export function formatDecimal(value: number, digits = 1): string {
  if (!Number.isFinite(value)) {
    return '—';
  }
  return value.toLocaleString('es-CO', { minimumFractionDigits: digits, maximumFractionDigits: digits });
}

export function formatKw(value: number): string {
  return `${formatDecimal(value, 1)} kW`;
}

export function formatKwh(value: number, digits = 1): string {
  return `${formatDecimal(value, digits)} kWh`;
}

export function formatPercent(value: number): string {
  if (!Number.isFinite(value)) {
    return '—';
  }
  return `${formatDecimal(value, 1)}%`;
}

/** Fecha/hora corta local. */
export function formatDateTime(iso: string | null | undefined): string {
  if (!iso) {
    return '—';
  }
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) {
    return '—';
  }
  return date.toLocaleString('es-CO', {
    day: '2-digit',
    month: 'short',
    hour: '2-digit',
    minute: '2-digit',
  });
}

/** Hora `HH:MM:SS` para el eje de la gráfica. */
export function formatClock(timestamp: number): string {
  return new Date(timestamp).toLocaleTimeString('es-CO', {
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
  });
}

/** Tiempo relativo legible ("hace 12 s", "hace 3 min"). */
export function formatRelative(iso: string | null | undefined): string {  if (!iso) {
    return 'sin señal';
  }
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) {
    return '—';
  }
  const seconds = Math.max(0, Math.round((Date.now() - date.getTime()) / 1000));
  if (seconds < 60) {
    return `hace ${seconds} s`;
  }
  const minutes = Math.round(seconds / 60);
  if (minutes < 60) {
    return `hace ${minutes} min`;
  }
  const hours = Math.round(minutes / 60);
  if (hours < 24) {
    return `hace ${hours} h`;
  }
  const days = Math.round(hours / 24);
  return `hace ${days} d`;
}

/**
 * Detecta nombres DEMO provistos por el backend (p. ej. "DEMO — Bogotá Centro").
 * Sirve para marcarlos explícitamente en la UI.
 */
export function isDemoName(name: string | null | undefined): boolean {
  return typeof name === 'string' && name.trim().toUpperCase().startsWith('DEMO');
}
